module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "outpfm1"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "basic-paragraph basic-paragraph-override",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Copyright © 2013")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("By Laurence J. Yadon and Robert Barr Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("All rights reserved")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic italic-override"
  }, [_vm._v("The word “Pelican” and the depiction of a pelican are")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic italic-override"
  }, [_vm._v("trademarks of Pelican Publishing Company, Inc., and are")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('em', {
    staticClass: "italic italic-override"
  }, [_vm._v("registered in the U.S. Patent and Trademark Office.")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "bold bold-override"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Yadon, Laurence J., 1948-")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Outlaws with badges / by Laurence J. Yadon and Robert Barr Smith.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("pages cm")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Includes bibliographical references and index.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("ISBN 978-1-4556-1658-9 (paperback : alkaline paper)—ISBN 978-1-4556-1659-6 (e-book) 1. Outlaws—West (U.S.)—Biography. 2. Peace officers—West (U.S.)—Biography. 3. Frontier and pioneer life—West (U.S.) 4. West (U.S.)—History—1860-1890. 5. West (U.S.)—Biography. I. Smith, Robert B. (Robert Barr), 1933- II. Title.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("F594.Y33 2013")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("364.15")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("'")]), _c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("52092278—dc23")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("2012029882")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('img', {
    staticClass: "generated-style",
    attrs: {
      "alt": "ACIDCREA.EPS",
      "src": "Images/ACIDCREA_fmt.jpeg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph basic-paragraph-override-1",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("Published by Pelican Publishing Company, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-2"
  }, [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2303bbc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 66
// module chunks = 0